<template>

  <div class="contact-container">
    <div class="search-container">
      <el-input
        size="small"
        v-model="searchInput"
        placeholder="输入拼音或汉字快速搜索"
        @input="onClickSearch()"
        @keyup.enter.native="onClickSearch()">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-tabs v-if="!searchInput" v-model="activeTabName" @tab-click="tabClick">

      <!--成员-->
      <el-tab-pane
        label="成员"
        v-if="currentIsMember && hasMember"
        name="member">

        <div class="select-member-container">
          <div class="left-container">
            <el-tree
              ref="depTree"
              :data="originMembers"
              node-key="depId"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              :current-node-key="currentNodeKey"
              :render-content="renderFormTreeContent"
              @node-click="handleMemberTreeNodeClick"
              :props="memberProps">
            </el-tree>
          </div>
          <div
            class="right-container"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="loadMoreUser"
            :infinite-scroll-disabled="disabledLoadMore">

            <template v-if="!loading && selectDep">
              <el-checkbox
                v-if="!radioMember && memberMap[selectDep.depId] && memberMap[selectDep.depId].length"
                style="margin-bottom: 5px;"
                v-model="allSelectUserMap[selectDep.depId]"
                @change="allSelectChange">
                全选
              </el-checkbox>

              <el-checkbox-group
                v-if="!radioMember"
                v-show="memberMap[selectDep.depId] && memberMap[selectDep.depId].length"
                v-model="selected.user">
                <el-checkbox
                  v-for="user in memberMap[selectDep.depId]"
                  :disabled="availableMember(user.userId) || Boolean(user.leave && !selected.user.includes(user.userId))"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                v-show="memberMap[selectDep.depId] && memberMap[selectDep.depId].length"
                @change="radioUserChange"
                v-model="selected.radioUser">
                <el-radio
                  v-for="user in memberMap[selectDep.depId]"
                  :disabled="availableMember(user.userId) || Boolean(radioMember && user.leave)"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-radio>
              </el-radio-group>

              <p v-if="loadingMore">加载中...</p>


              <el-alert
                v-show="!memberMap[selectDep.depId] || !memberMap[selectDep.depId].length"
                :closable="false"
                title="暂无可用人员"
                type="error">
              </el-alert>
            </template>
          </div>
        </div>
      </el-tab-pane>

      <!--角色-->
      <el-tab-pane
        label="角色"
        v-if="currentIsMember && hasRole"
        name="role">

        <div class="select-member-container" v-if="activeTabName === 'role'">
          <div class="left-container">
            <el-tree
              ref="roleTree"
              :data="originRole"
              node-key="roleId"
              default-expand-all
              highlight-current
              :current-node-key="currentRoleNodeKey"
              :render-content="renderRoleDataContent"
              @node-click="handleRoleTreeNodeClick"
              :props="roleProps">
            </el-tree>
          </div>
          <div
            class="right-container"
            v-loading="roleLoading"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="loadMoreRoleUser"
            :infinite-scroll-disabled="disabledLoadMoreRole">

            <template v-if="!roleLoading && selectRole">

              <el-checkbox-group
                v-if="!radioMember"
                v-show="roleMemberMap[selectRole.roleId] && roleMemberMap[selectRole.roleId].length"
                v-model="selected.user">
                <el-checkbox
                  v-for="user in roleMemberMap[selectRole.roleId]"
                  :disabled="availableMember(user.userId)"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                v-show="roleMemberMap[selectRole.roleId] && roleMemberMap[selectRole.roleId].length"
                @change="radioUserChange"
                v-model="selected.radioUser">
                <el-radio
                  v-for="user in roleMemberMap[selectRole.roleId]"
                  :disabled="availableMember(user.userId)"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-radio>
              </el-radio-group>

              <p v-if="loadingRoleMore">加载中...</p>


              <el-alert
                v-show="!roleMemberMap[selectRole.roleId] || !roleMemberMap[selectRole.roleId].length"
                :closable="false"
                title="暂无可用人员"
                type="error">
              </el-alert>
            </template>
          </div>
        </div>

        <el-alert
          v-show="!originRole.length"
          :closable="false"
          title="暂无可用角色"
          type="error">
        </el-alert>
      </el-tab-pane>

      <!--外部联系人-->
      <el-tab-pane
        v-if="hasExternal"
        name="external"
        label="外部联系人">

        <div class="select-member-container" v-if="activeTabName === 'external'">
          <div class="left-container">
            <el-tree
              ref="labelTree"
              :data="extLabelDataList"
              node-key="labelId"
              default-expand-all
              highlight-current
              :current-node-key="currentLabelNodeKey"
              :render-content="renderLabelTreeContent"
              @node-click="handleLabelTreeNodeClick"
              :props="extLabelProps">
            </el-tree>
          </div>
          <div
            class="right-container"
            v-loading="labelLoading"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="loadMoreExtUser"
            :infinite-scroll-disabled="disabledLoadMoreExt">

            <template v-if="!labelLoading && selectLabel">
              <el-checkbox
                v-if="!radioMember && labelMemberMap[selectLabel.labelId] && labelMemberMap[selectLabel.labelId].length"
                style="margin-bottom: 5px;"
                v-model="allSelectExtMap[selectLabel.labelId]"
                @change="allSelectExtChange">
                全选
              </el-checkbox>

              <el-checkbox-group
                v-if="!radioMember"
                v-show="labelMemberMap[selectLabel.labelId] && labelMemberMap[selectLabel.labelId].length"
                v-model="selected.ext">
                <el-checkbox
                  v-for="ext in labelMemberMap[selectLabel.labelId]"
                  :disabled="available(availableExt, ext.userId) || Boolean(ext.leave && !selected.ext.includes(ext.userId))"
                  :label="ext.userId"
                  :key="ext.userId">
                  {{ext.orgUserName.length ? ext.orgUserName : ext.orgUserMobile}}
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                v-show="labelMemberMap[selectLabel.labelId] && labelMemberMap[selectLabel.labelId].length"
                @change="radioExtChange"
                v-model="selected.radioExt">
                <el-radio
                  v-for="ext in labelMemberMap[selectLabel.labelId]"
                  :disabled="available(availableExt, ext.userId) || Boolean(ext.leave)"
                  :label="ext.userId"
                  :key="ext.userId">
                  {{ext.orgUserName.length ? ext.orgUserName : ext.orgUserMobile}}
                </el-radio>
              </el-radio-group>

              <p v-if="loadingLabelMore">加载中...</p>


              <el-alert
                v-show="!labelMemberMap[selectLabel.labelId] || !labelMemberMap[selectLabel.labelId].length"
                :closable="false"
                title="暂无可用人员"
                type="error">
              </el-alert>
            </template>
          </div>
        </div>

        <el-alert
          v-show="!extLabelDataList.length"
          :closable="false"
          title="暂无可用人员"
          type="error">
        </el-alert>
      </el-tab-pane>

      <!--外部联系人标签-->
      <el-tab-pane
        label="外部联系人标签"
        v-if="false"
        name="label">
        <template v-if="customDataMap['label']">

          <el-checkbox-group
            v-if="!radioMember"
            class="ry-label"
            v-show="customDataMap['label'].dataList.length"
            v-model="selected.ext">
            <el-tree
              :data="customDataMap['label'].dataList"
              default-expand-all
              :props="customProps"
              :render-content="renderCustomMemberDataContent">
            </el-tree>
          </el-checkbox-group>

          <el-radio-group
            v-else
            v-show="customDataMap['label'].dataList.length"
            @change="radioExtChange"
            v-model="selected.radioExt">
            <el-tree
              :data="customDataMap['label'].dataList"
              default-expand-all
              :props="customProps"
              :render-content="renderCustomMemberDataContent">
            </el-tree>
          </el-radio-group>
        </template>

        <el-alert
          v-if="!loading && !customDataMap['label']"
          :closable="false"
          title="暂无可用外部联系人标签"
          type="error">
        </el-alert>
      </el-tab-pane>

      <!--自定义选人标签-->
      <el-tab-pane
        v-for="tab in customTabs"
        :key="tab.key"
        :label="tab.name"
        :name="tab.key">

        <div style="width: 100%; min-height: 300px">
          <template v-if="customDataMap[tab.key] && customDataMap[tab.key].resultType === 'GROUP'">

            <template v-if="customDataMap[tab.key].memberType === 'MEMBER'">

              <el-checkbox-group
                v-if="!radioMember"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.user">
                <el-tree
                  :data="customDataMap[tab.key].dataList"
                  default-expand-all
                  :props="customProps"
                  :render-content="renderCustomMemberDataContent">
                </el-tree>
              </el-checkbox-group>

              <el-radio-group
                v-else
                v-show="customDataMap[tab.key].dataList.length"
                @change="radioUserChange"
                v-model="selected.radioUser">
                <el-tree
                  :data="customDataMap[tab.key].dataList"
                  default-expand-all
                  :props="customProps"
                  :render-content="renderCustomMemberDataContent">
                </el-tree>
              </el-radio-group>

            </template>

            <template v-if="customDataMap[tab.key].memberType === 'EXTERNAL'">

              <el-checkbox-group
                v-if="!radioMember"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.ext">
                <el-tree
                  :data="customDataMap[tab.key].dataList"
                  default-expand-all
                  :props="customProps"
                  :render-content="renderCustomMemberDataContent">
                </el-tree>
              </el-checkbox-group>

              <el-radio-group
                v-else
                v-show="customDataMap[tab.key].dataList.length"
                @change="radioExtChange"
                v-model="selected.radioExt">
                <el-tree
                  :data="customDataMap[tab.key].dataList"
                  default-expand-all
                  :props="customProps"
                  :render-content="renderCustomMemberDataContent">
                </el-tree>
              </el-radio-group>
            </template>

          </template>

          <template v-if="customDataMap[tab.key] && customDataMap[tab.key].resultType === 'LIST'">

            <template v-if="customDataMap[tab.key].memberType === 'MEMBER'">

              <el-checkbox-group
                v-if="!radioMember"
                class="ry-role"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.user">
                <el-checkbox
                  v-for="user in customDataMap[tab.key].dataList"
                  :key="user.userId"
                  :label="user.userId">
                  {{user.userName}}
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                style="margin-left: 10px;"
                @change="radioUserChange"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.radioUser">
                <el-radio
                  style=" display: block; margin-bottom: 5px;"
                  v-for="user in customDataMap[tab.key].dataList"
                  :key="user.userId"
                  :label="user.userId">
                  {{user.userName}}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="customDataMap[tab.key].memberType === 'EXTERNAL'">

              <el-checkbox-group
                v-if="!radioMember"
                class="ry-role"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.ext">
                <el-checkbox
                  v-for="user in customDataMap[tab.key].dataList"
                  :key="user.userId"
                  :label="user.userId">
                  {{user.userName}}
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                style="margin-left: 10px;"
                @change="radioExtChange"
                v-show="customDataMap[tab.key].dataList.length"
                v-model="selected.radioExt">
                <el-radio
                  style=" display: block; margin-bottom: 5px;"
                  v-for="user in customDataMap[tab.key].dataList"
                  :key="user.userId"
                  :label="user.userId">
                  {{user.userName}}
                </el-radio>
              </el-radio-group>
            </template>

          </template>

          <el-alert
            v-show="!loading && (!customDataMap[tab.key] || !customDataMap[tab.key].dataList.length)"
            :closable="false"
            title="暂无可用人员"
            type="error">
          </el-alert>
        </div>

      </el-tab-pane>

    </el-tabs>

    <div v-if="searchInput" class="ry-contacts__box-search-container">
      <div class="select-member-container" style="height: 100%">
        <div class="left-container">
          <div
            class="item"
            :style="{background: searchTab === 'member' ? '#f0f7ff' : ''}"
            @click="searchTab = 'member'">
            <div class="title">成员</div>
          </div>

          <div class="item" :style="{background: searchTab === 'dep' ? '#f0f7ff' : ''}" @click="searchTab = 'dep'">
            <div class="title">部门</div>
          </div>
          <div class="item" :style="{background: searchTab === 'role' ? '#f0f7ff' : ''}" @click="searchTab = 'role'">
            <div class="title">角色</div>
          </div>
          <div class="item" :style="{background: searchTab === 'ext' ? '#f0f7ff' : ''}" @click="searchTab = 'ext'">
            <div class="title">外部联系人</div>
          </div>
        </div>

        <div v-if="searchTab === 'member'">
          <div
            class="right-container"
            v-loading="searchLoading"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="loadMoreSearchUser"
            :infinite-scroll-disabled="disabledLoadSearchMore">

            <template v-if="!searchLoading">

              <el-checkbox-group
                v-if="!radioMember"
                v-model="selected.user">
                <el-checkbox
                  v-for="user in searchResults.member"
                  :disabled="availableMember(user.userId)"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                @change="radioUserChange"
                v-model="selected.radioUser">
                <el-radio
                  v-for="user in searchResults.member"
                  :disabled="availableMember(user.userId)"
                  :label="user.userId"
                  :key="user.userId">
                  <el-avatar size="small" :src="user.headImg"></el-avatar>
                  {{user.nickname}}({{handleTel(user.telephone)}})
                </el-radio>
              </el-radio-group>

              <p v-if="loadingMore">加载中...</p>

              <el-alert
                v-show="!searchResults.member || !searchResults.member.length"
                :closable="false"
                title="暂无可用人员"
                type="error">
              </el-alert>
            </template>
          </div>
        </div>

        <div v-if="searchTab === 'dep'" class="right-container">

          <el-checkbox-group
            v-if="!radioMember"
            class="ry-role"
            v-model="selected.dep">
            <el-checkbox
              v-for="dep in searchResults.dep"
              :key="dep.depId"
              :label="dep.depId"
              :disabled="available(availableDeps, dep.depId)">
              {{dep.depName}}
            </el-checkbox>
          </el-checkbox-group>

          <el-radio-group
            v-else
            style="margin-left: 10px;"
            @change="radioDepChange"
            v-model="selected.radioDep">
            <el-radio
              style=" display: block; margin-bottom: 5px;"
              v-for="dep in searchResults.dep"
              :key="dep.depId"
              :label="dep.depId"
              :disabled="available(availableDeps, dep.depId)">
              {{dep.depName}}
            </el-radio>
          </el-radio-group>


          <el-alert
            v-show="!searchResults.dep || !searchResults.dep.length"
            :closable="false"
            title="暂无可用部门"
            type="error">
          </el-alert>
        </div>

        <div v-if="searchTab === 'role'" class="right-container">
          <el-checkbox-group
            class="ry-role"
            v-model="selected.role">
            <el-checkbox
              v-for="role in searchResults.role"
              :key="role.roleCustomId"
              :label="role.roleCustomId"
              :disabled="available(availableRoles, role.roleCustomId)">
              {{role.roleName}}
            </el-checkbox>
          </el-checkbox-group>

          <el-alert
            v-show="!searchResults.role || !searchResults.role.length"
            :closable="false"
            title="暂无可用角色"
            type="error">
          </el-alert>
        </div>

        <div v-if="searchTab === 'ext'">

          <div
            class="right-container"
            v-loading="searchExtLoading"
            :infinite-scroll-immediate="false"
            v-infinite-scroll="loadMoreExtSearchUser"
            :infinite-scroll-disabled="disabledLoadExtSearchMore">

            <template v-if="!searchExtLoading">

              <el-checkbox-group
                v-if="!radioMember"
                class="ry-role"
                v-model="selected.ext">
                <el-checkbox
                  v-for="ext in searchResults.external"
                  :key="ext.userId"
                  :label="ext.userId"
                  :disabled="available(availableExt, ext.userId) || Boolean(ext.leave && !selected.ext.includes(ext.userId))">
                  {{ext.userName || ext.orgUserName}}
                </el-checkbox>
              </el-checkbox-group>

              <el-radio-group
                v-else
                style="margin-left: 10px;"
                @change="radioExtChange"
                v-model="selected.radioExt">
                <el-radio
                  style="margin-bottom: 5px;"
                  v-for="ext in searchResults.external"
                  :key="ext.userId"
                  :label="ext.userId"
                  :disabled="available(availableExt, ext.userId) || Boolean(ext.leave)">
                  {{ext.userName || ext.orgUserName}}
                </el-radio>
              </el-radio-group>

              <p v-if="loadingExtMore">加载中...</p>

              <el-alert
                v-show="!searchResults.external || !searchResults.external.length"
                :closable="false"
                title="暂无可用人员"
                type="error">
              </el-alert>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="select-member-footer">

      <template v-if="!radioMember">
        <!--人员多选-->
        <span v-for="(userId, idx) in selected.user" :key="'user' + userId">

        <el-tag
          closable
          disable-transitions
          @close="removeSelectUser(userId, idx)"
          v-if=" $store.getters.userListMap[userId]"
          type="info"
          class="ry-contacts__tag">
          <span>
              {{$store.getters.userListMap[userId]['nickname']}}
            </span>
        </el-tag>

        <el-tag
          closable
          disable-transitions
          @close="removeSelectUser(userId, idx)"
          v-if=" $store.getters.leaveMemberListMap[userId]"
          type="info"
          class="ry-contacts__tag">
          <span>
              {{$store.getters.leaveMemberListMap[userId]['nickname']}}
            </span>
        </el-tag>
        </span>

        <!--部门多选-->
        <el-tag
          closable
          disable-transitions
          v-for="(depId, idx) in selected.dep"
          v-if="$store.getters.depListMap[depId]"
          @close="removeSelectDep(depId, idx)"
          class="ry-contacts__tag"
          :key="'dep' +  depId">
          <span>
              {{$store.getters.depListMap[depId]['depName']}}
            </span>
        </el-tag>

        <!--外部联系人多选-->
        <span v-for="(userId, idx) in selected.ext" :key="'ext' + userId">
          <el-tag
            closable
            disable-transitions
            @close="removeSelectExt(userId, idx)"
            v-if="$store.getters.extMap[userId]"
            type="warning"
            class="ry-contacts__tag">
          <span>
              {{$store.getters.extMap[userId]['orgUserName'] ? $store.getters.extMap[userId]['orgUserName'] : $store.getters.extMap[userId]['nickname']}}
            </span>
        </el-tag>

          <el-tag
            closable
            disable-transitions
            @close="removeSelectExt(userId, idx)"
            v-if="$store.getters.leaveExternalMap[userId]"
            type="warning"
            class="ry-contacts__tag">
          <span>
              {{$store.getters.leaveExternalMap[userId]['orgUserName'] ? $store.getters.leaveExternalMap[userId]['orgUserName'] : $store.getters.leaveExternalMap[userId]['nickname']}}
            </span>
        </el-tag>
        </span>


        <!--外部联系人标签多选-->
        <el-tag
          closable
          disable-transitions
          v-for="(labelId, idx) in selected.label"
          v-if="$store.getters.extLabelMap[labelId]"
          @close="removeSelectLabel(labelId, idx)"
          class="ry-contacts__tag"
          :key="'label' +  labelId">
          <span>
              {{$store.getters.extLabelMap[labelId]['labelName']}}
            </span>
        </el-tag>

      </template>

      <!--人员单选-->
      <el-tag
        closable
        disable-transitions
        @close="selected.radioUser = null"
        v-if="!!radioMember && selected.radioUser && $store.getters.userListMap[selected.radioUser]"
        class="ry-contacts__tag"
        type="info"
        :key="'user' + selected.radioUser">
        <span>
              {{$store.getters.userListMap[selected.radioUser]['nickname']}}
            </span>
      </el-tag>
      <el-tag
        closable
        disable-transitions
        @close="selected.radioUser = null"
        v-if="!!radioMember && selected.radioUser && $store.getters.leaveMemberListMap[selected.radioUser]"
        class="ry-contacts__tag"
        type="info"
        :key="'user' + selected.radioUser">
        <span>
              {{$store.getters.leaveMemberListMap[selected.radioUser]['nickname']}}
            </span>
      </el-tag>

      <!--部门单选-->
      <el-tag
        closable
        disable-transitions
        @close="selected.radioDep = null"
        v-if="!!radioMember && selected.radioDep && $store.getters.depListMap[selected.radioDep]"
        class="ry-contacts__tag"
        type="info"
        :key="'dep' + selected.radioDep">
        <span>
              {{$store.getters.depListMap[selected.radioDep]['depName']}}
            </span>
      </el-tag>

      <!--角色单选-->
      <el-tag
        closable
        disable-transitions
        v-for="(roleCustomId, idx) in selected.role"
        @close="removeSelectRole(roleCustomId, idx)"
        v-if="$store.getters.rolesMap[roleCustomId]"
        type="success"
        class="ry-contacts__tag"
        :key="'role' + roleCustomId">
        <span>
              {{$store.getters.rolesMap[roleCustomId]['roleName']}}
            </span>
      </el-tag>

      <!--外部联系人单选-->
      <el-tag
        closable
        disable-transitions
        @close="selected.radioExt = null"
        v-if="!!radioMember && selected.radioExt && $store.getters.extMap[selected.radioExt]"
        class="ry-contacts__tag"
        type="info"
        :key="'ext' + selected.radioExt">
        <span>
              {{$store.getters.extMap[selected.radioExt]['orgUserName'] ? $store.getters.extMap[selected.radioExt]['orgUserName'] : $store.getters.extMap[selected.radioExt]['nickname']}}
            </span>
      </el-tag>
      <el-tag
        closable
        disable-transitions
        @close="selected.radioExt = null"
        v-if="!!radioMember && selected.radioExt && $store.getters.leaveExternalMap[selected.radioExt]"
        class="ry-contacts__tag"
        type="info"
        :key="'ext' + selected.radioExt">
        <span>
              {{$store.getters.leaveExternalMap[selected.radioExt]['orgUserName'] ? $store.getters.leaveExternalMap[selected.radioExt]['orgUserName'] : $store.getters.leaveExternalMap[selected.radioExt]['nickname']}}
            </span>
      </el-tag>

      <!--外部联系人标签单选-->
      <el-tag
        closable
        disable-transitions
        @close="selected.radioLabel = null"
        v-if="!!radioMember && selected.radioLabel && $store.getters.extLabelMap[selected.radioLabel]"
        class="ry-contacts__tag"
        type="info"
        :key="'label' + selected.radioLabel">
        <span>
              {{$store.getters.extLabelMap[selected.radioLabel]['labelName']}}
            </span>
      </el-tag>

    </div>

    <div class="button-container">
      <van-button type="default" @click="selectMemberCancel">取消</van-button>
      <van-button type="primary" @click="selectMemberConfirm">确定</van-button>
    </div>
  </div>
</template>


<script>
  import {FORM_ITEM__DEPARTMENT, FORM_ITEM__MEMBER, FORM_ITEM__TABLE} from "../../RyForm/types"
  import {arrayUnique, clone, hiddenStr} from "../../../assets/js/Untis"
  import {uuid} from "../../RyForm/utils"
  import {SUCCESS} from "../../store/types"
  import PinyinMatch from 'pinyin-match'


  export default {
    props: {
      title: {
        type: String,
        default: '选人'
      },
      // 显示选中的tag
      showTag: {
        type: Boolean,
        default: true
      },
      // 显示选中的tag个数
      showTagNum: {
        type: Number,
        default: 0
      },
      // 人员单选
      radioMember: {
        type: Boolean,
        default: false
      },

      // formSet 实例
      formSet: {
        type: Object || null,
        default: null
      },

      // 是否有部门
      hasDep: {
        type: Boolean,
        default: true
      },
      // 是否有动态
      hasDynamic: {
        type: Boolean,
        default: true
      },
      // 使用有外部联系人
      hasExternal: {
        type: Boolean,
        default: true
      },
      // 是否有人员选择
      hasMember: {
        type: Boolean,
        default: true
      },
      // 是否有角色
      hasRole: {
        type: Boolean,
        default: true
      },
      // 是否有外部联系人标签
      hasLabel: {
        type: Boolean,
        default: true
      },
      // 是否有当前用户
      hasCurrent: {
        type: Boolean,
        default: true
      },

      // 部门可选择的 idList
      availableDeps: {
        type: Array,
        default: () => []
      },
      // 成员可选择的 idList
      availableMembers: {
        type: Array,
        default: () => []
      },
      // 角色可选择的 idList
      availableRoles: {
        type: Array,
        default: () => []
      },
      // 外部联系人可选择的 idList
      availableExt: {
        type: Array,
        default: () => []
      },

      // 成员不可选择的 idList
      disableMembers: {
        type: Array,
        default: () => []
      },

      // 选中的部门
      selectedDep: {
        type: Array,
        default: () => []
      },
      // 选中的角色
      selectedRole: {
        type: Array,
        default: () => []
      },
      // 选中的人员
      selectedUser: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人
      selectedExt: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人标签
      selectedLabel: {
        type: Array,
        default: () => []
      },
      // 选中的动态
      selectedDyn: {
        type: Array,
        default: () => []
      },
      // 是否是单选
      isSingle: {
        type: Boolean,
        default: false
      },
      // 点击打开弹窗按钮是否隐藏
      disabled: {
        type: Boolean,
        default: false
      },
      // 只读， 不能点击打开弹窗, 不能删除已选人员
      isReadOnly: {
        type: Boolean,
        default: false
      },
      /*
      * 自定义标签tab
      * {
      *   key: '',
      *   name: ''
      * }
      * */
      customTabs: {
        type: Array,
        default: () => []
      },
      fieldId: {
        type: String,
        default: ''
      }
    },
    data() {

      return {
        // 选人dialog的tabs active
        activeTabName: "member",
        // 缓存的选中人
        selected: {
          dep: clone(this.selectedDep),
          radioDep: this.selectedDep[0],
          role: clone(this.selectedRole),
          radioRole: this.selectedRole[0],
          user: clone(this.selectedUser ? this.selectedUser : []),
          radioUser: this.selectedUser ? this.selectedUser[0] : '',
          ext: clone(this.selectedExt),
          radioExt: this.selectedExt[0],
          label: clone(this.selectedLabel),
          radioLabel: this.selectedLabel[0],
          dyn: clone(this.selectedDyn).map(dyn => dyn.fieldId),
          radioDyn: clone(this.selectedDyn).map(dyn => dyn.fieldId)[0],
        },
        // 选择人员dialog conf
        dialogConf: {
          visible: false,
        },
        // 人员tree 渲染使用 props
        memberProps: {
          children: "children",
          label: "depName"
        },
        // 部门props
        depProps: {
          children: "subDepList",
          label: "depName"
        },
        // 角色props
        roleProps: {
          children: "userInfoList",
          label: "roleName"
        },
        // 外部联系人标签props
        extLabelProps: {
          children: "labelNameList",
          label: "labelName"
        },
        // 外部联系人标签props
        customProps: {
          children: "children",
          label: "groupName"
        },

        // 外部联系人
        externalList: [],
        externalMap: {},
        extLabelList: [],

        // 外部联系人标签
        labelList: [],
        labelMap: {},
        // 自己是否是项目部成员，或者是外部联系人
        isMember: true,

        searchInput: '',
        searchResults: {
          member: [],
          role: [],
          dep: [],
          external: []
        },

        loading: false,
        customDataMap: {},

        loadingMore: false,
        selectDep: null,
        allSelectUserMap: {},
        allSelectExtMap: {},
        memberMap: {},
        pageMap: {},

        searchLoading: false,
        searchPageInfo: {
          currentPage: 1,
          pageSize: 50,
          totalPage: 0,
          totalCount: 0
        },
        searchTab: 'member',

        loadingExtMore: false,
        searchExtLoading: false,
        searchExtPageInfo: {
          currentPage: 1,
          pageSize: 50,
          totalPage: 0,
          totalCount: 0
        },

        labelLoading: false,
        loadingLabelMore: false,
        selectLabel: null,
        labelMemberMap: {},
        labelPageMap: {},

        roleLoading: false,
        loadingRoleMore: false,
        selectRole: null,
        roleMemberMap: {},
        rolePageMap: {},
      }
    },
    created() {
    },
    computed: {
      currentIsMember() {
        return this.$store.getters.adminInfo.isMember
        // return this.$store.state.userList.some(user => user.userId === this.$store.getters.userId)
      },
      currentNodeKey() {
        const organization = this.$store.state.depInfo || {}
        return this.selectDep ? this.selectDep.depId : organization.depId
      },
      currentLabelNodeKey() {
        return this.selectLabel ? this.selectLabel.labelId : ''
      },
      currentRoleNodeKey() {
        return this.selectRole ? this.selectRole.roleId : ''
      },
      // 角色数据源
      originRole() {
        /**
         {
            "roleId": 9,
            "companyId": "1100590181242769408",
            "roleName": "财务",
            "roleIcon": "",
            "userInfoList": []
          }
         */
        if (!this.selectRole) {
          if (this.$store.state.roleList && this.$store.state.roleList.length) {
            this.selectRole = clone(this.$store.state.roleList[0])
          }
          this.handleRoleTreeNodeClick(this.selectRole)
          if (this.$refs.roleTree) {
            this.$refs.roleTree.setCurrentKey(this.selectRole.roleId)
          }
        }
        return clone(this.$store.state.roleList)
      },
      // 人员数据源
      originMembers() {
        const organization = this.$store.state.depInfo
        let members = this.$store.state.userList.filter(user => !this.availableMember(user.userId))
        let leaveMemberList = this.$store.getters.leaveMemberList.filter(user => {
          this.$set(user, 'leave', 1)
          return user
        })

        let that = this

        function organizationMap(depList) {
          let list = []
          if (depList) {
            depList.forEach(({depName, depId, subDepList, memberList = []}) => {
              list.push({
                depName,
                depId,
                children: [
                  // ...memberList.filter(user => !that.availableMember(user.userId)),
                  ...organizationMap(subDepList),
                ]
              })
            })
          }
          return list
        }

        const arrTemp = [
          // ...organizationMap(organization.subDepList),
          {
            depName: '全部人员',
            depId: 'all',
            children: [
              // ...members
            ]
          },
          ...organizationMap(organization.subDepList)
        ]
        if (leaveMemberList && leaveMemberList.length) {
          arrTemp.push({
            depName: '已离职人员',
            depId: 'leave',
            children: [
              // ...leaveMemberList
            ]
          })
        }

        if (!this.selectDep) {
          this.selectDep = {
            depName: '全部人员',
            depId: 'all',
            children: []
          }
          this.handleMemberTreeNodeClick(this.selectDep)
        }
        return arrTemp
      },
      // 组织架构数据源
      originOrganization() {
        /**
         {
              "depId":30,
              "depName":"大胖不胖",
              "hasSub":1,
              "memberNumber":3,
              "memberList":[],
              "subDepList":[],
              "chargePerson":[]
            }
         */
        const organization = this.$store.state.depInfo
        return organization.subDepList || []
      },
      extLabelDataList() {
        let leaveMemberList = this.$store.getters.leaveExternalList.filter(user => {
          this.$set(user, 'leave', 1)
          return user
        })
        const arr = [
          {
            labelId: 'all',
            labelName: '全部外部联系人',
            labelNameList: []
          }
        ]
        this.$store.getters.extLabelList.forEach(labelGroup => {
          let labelGroupTmp = {
            labelId: labelGroup.labelGroupId,
            labelName: labelGroup.labelGroupName,
            isGroup: 1,
            color: labelGroup.color,
            labelNameList: labelGroup.labelNameList
          }
          arr.push(labelGroupTmp)
        })
        if (leaveMemberList && leaveMemberList.length) {
          arr.push({
            labelName: '已离职人员',
            labelId: 'leave',
            labelNameList: [
              // ...leaveMemberList
            ]
          })
        }

        if (!this.selectLabel) {
          this.selectLabel = {
            labelName: '全部外部联系人',
            labelId: 'all',
            labelNameList: []
          }
          this.handleLabelTreeNodeClick(this.selectLabel)
        }
        return arr
      },
      originLabelList() {

        if (!this.customDataMap[this.activeTabName] || !this.customDataMap[this.activeTabName].length) {
          return []
        }
        const dataList = []
        this.extLabelList.forEach(item => {
          const children = []
          dataList.push({
            labelName: item.labelGroupName,
            labelId: item.labelGroupId,
            children
          })
          item.labelNameList.forEach(label => {
            children.push({
              labelName: label.labelName,
              labelId: label.labelId,
              children: [...label.userInfoList]
            })
          })
        })

        return dataList
      },
      originExts() {
        const extList = this.$store.getters.extList.filter(ext => !this.available(this.availableExt, ext.userId))
        const leaveExternalList = this.$store.getters.leaveExternalList.filter(ext => !this.available(this.availableExt, ext.userId))
        return [...extList, ...leaveExternalList]
      },
      showSelectUser() {
        return this.selectedUser.slice(0, this.showTagNum)
      },
      showSelectDep() {
        if (this.showSelectUser.length > this.showTagNum) {
          return []
        } else {
          return this.selectedDep.slice(0, this.showTagNum - this.showSelectUser.length)
        }
      },
      showSelectRole() {
        if (this.showSelectUser.length + this.showSelectDep.length > this.showTagNum) {
          return []
        } else {
          return this.selectedRole.slice(0, this.showTagNum - (this.showSelectUser.length + this.showSelectDep.length))
        }
      },
      showSelectExt() {
        if (this.showSelectUser.length + this.showSelectDep.length + this.showSelectRole.length > this.showTagNum) {
          return []
        } else {
          return this.selectedExt.slice(0, this.showTagNum -
            (this.showSelectUser.length + this.showSelectDep.length + this.showSelectRole.length))
        }
      },
      showSelectLabel() {
        if (this.showSelectUser.length + this.showSelectDep.length + this.showSelectRole.length + this.showSelectExt.length > this.showTagNum) {
          return []
        } else {
          return this.selectedLabel.slice(0, this.showTagNum -
            (this.showSelectUser.length + this.showSelectDep.length + this.showSelectRole.length + this.showSelectExt.length))
        }
      },

      radioCurrent: {
        set(val) {
          if (this.isMember) {
            this.selected.radioUser = val
          } else {
            this.selected.radioExt = val
          }
        },
        get() {
          return this.isMember ? this.selected.radioUser : this.selected.radioExt
        }

      },
      checkboxCurrent: {
        set(val) {
          if (this.isMember) {
            this.selected.user.splice(0, this.selected.user.length, ...val)
          } else {
            this.selected.ext.splice(0, this.selected.ext.length, ...val)
          }
        },
        get() {
          return this.isMember ? this.selected.user : this.selected.ext
        }
      },
      disabledLoadMore() {
        if (this.selectDep.depId === 'leave') {
          return true
        }
        const pageInfo = this.pageMap[this.selectDep.depId]
        if (!pageInfo) {
          return true
        }
        return this.loading || pageInfo.totalPage === 0 || pageInfo.currentPage >= pageInfo.totalPage
      },
      disabledLoadSearchMore() {
        return this.searchLoading || this.searchPageInfo.totalPage === 0 || this.searchPageInfo.currentPage >= this.searchPageInfo.totalPage
      },
      disabledLoadExtSearchMore() {
        return this.searchExtLoading || this.searchExtPageInfo.totalPage === 0 || this.searchExtPageInfo.currentPage >= this.searchExtPageInfo.totalPage
      },
      disabledLoadMoreExt() {
        if (!this.selectLabel) {
          return true
        }
        if (this.selectLabel.labelId === 'leave') {
          return true
        }
        const pageInfo = this.labelPageMap[this.selectLabel.labelId]
        if (!pageInfo) {
          return true
        }
        return this.labelLoading || pageInfo.totalPage === 0 || pageInfo.currentPage >= pageInfo.totalPage
      },
      disabledLoadMoreRole() {
        if (!this.selectRole) {
          return true
        }
        const pageInfo = this.rolePageMap[this.selectRole.roleId]
        if (!pageInfo) {
          return true
        }
        return this.roleLoading || pageInfo.totalPage === 0 || pageInfo.currentPage >= pageInfo.totalPage
      },
    },
    methods: {
      // 删除预选
      removeSelectDep(depId, idx) {
        if (this.selected.dep[idx] !== depId) {
          idx = this.selected.dep.indexOf(depId)
        }
        this.selected.dep.splice(idx, 1)
      },
      removeSelectRole(roleCustomId, idx) {
        if (this.selected.role[idx] !== roleCustomId) {
          idx = this.selected.role.indexOf(roleCustomId)
        }
        this.selected.role.splice(idx, 1)
      },
      removeSelectExt(userId, idx) {
        if (this.selected.ext[idx] !== userId) {
          idx = this.selected.ext.indexOf(userId)
        }
        this.selected.ext.splice(idx, 1)
      },
      removeSelectLabel(labelId, idx) {
        if (this.selected.label[idx] !== labelId) {
          idx = this.selected.label.indexOf(labelId)
        }
        this.selected.label.splice(idx, 1)
      },
      // 多选删除预选的人
      removeSelectUser(userId, idx) {
        if (this.selected.user[idx] !== userId) {
          idx = this.selected.user.indexOf(userId)
        }
        this.selected.user.splice(idx, 1)
      },
      // 单选删除预选的人
      removeSelectRadioUser() {
        this.selected.radioUser = null
      },
      removeSelectDyn(fieldId, idx) {
        if (this.selected.dyn[idx] !== fieldId) {
          idx = this.selected.dyn.indexOf(fieldId)
        }
        this.selected.dyn.splice(idx, 1)
      },

      // 删除已选
      removeDep(depId, idx) {
        if (this.selectedDep[idx] !== depId) {
          idx = this.selectedDep.indexOf(depId)
        }
        this.selectedDep.splice(idx, 1)
        this.emitChange()
      },
      removeRole(roleCustomId, idx) {
        if (this.selectedRole[idx] !== roleCustomId) {
          idx = this.selectedRole.indexOf(roleCustomId)
        }
        this.selectedRole.splice(idx, 1)
        this.emitChange()
      },
      removeExt(userId, idx) {
        if (this.selectedExt[idx] !== userId) {
          idx = this.selectedExt.indexOf(userId)
        }
        this.selectedExt.splice(idx, 1)
        this.$emit('deleteUser', {
          member: null,
          role: null,
          depart: null,
          external: userId,
          label: null
        })
        this.emitChange()
      },
      removeLabel(labelId, idx) {
        if (this.selectedLabel[idx] !== labelId) {
          idx = this.selectedLabel.indexOf(labelId)
        }
        this.selectedLabel.splice(idx, 1)
        this.emitChange()
      },
      removeUser(userId, idx) {
        if (this.selectedUser[idx] !== userId) {
          idx = this.selectedUser.indexOf(userId)
        }
        this.selectedUser.splice(idx, 1)
        this.$emit('deleteUser', {
          member: userId,
          role: null,
          depart: null,
          external: null,
          label: null
        })
        this.emitChange()
      },
      removeDyn(fieldId, idx) {
        if (this.selectedDyn[idx].fieldId !== fieldId) {
          this.selectedDyn.some((item, index) => {
            if (fieldId === item.fieldId) {
              idx = index
              return true
            } else {
              return false
            }
          })
        }
        this.selectedDyn.splice(idx, 1)
        this.emitChange()
      },

      // 单选值发生变化
      radioUserChange(v) {
        if (this.selected.radioUser) {
          this.selected.radioDep = ''
          this.selected.radioRole = ''
          this.selected.radioExt = ''
          this.selected.radioLabel = ''
        }
      },
      radioDepChange() {
        if (this.selected.radioUser) {
          this.selected.radioRole = ''
          this.selected.radioDep = ''
          this.selected.radioExt = ''
          this.selected.radioLabel = ''
        }
      },
      radioRuleChange() {
        if (this.selected.radioUser) {
          this.selected.radioDep = ''
          this.selected.radioRole = ''
          this.selected.radioExt = ''
          this.selected.radioLabel = ''
        }
      },
      radioExtChange() {
        if (this.selected.radioExt) {
          this.selected.radioDep = ''
          this.selected.radioRole = ''
          this.selected.radioUser = ''
          this.selected.radioLabel = ''
        }
      },
      radioLabelChange() {
        if (this.selected.radioExt) {
          this.selected.radioDep = ''
          this.selected.radioRole = ''
          this.selected.radioUser = ''
          this.selected.radioExt = ''
        }
      },
      radioCurrentChange() {
        if (this.isMember) {
          this.radioUserChange()
        } else {
          this.radioExtChange()
        }
      },

      // 渲染选人 多选
      renderMemberDataContent(h, {node, data, store}) {
        return h("div", {staticClass: 'ry-member'}, this.renderMemberDataChildren(h, data))
      },
      // 渲染选人 多选
      renderMemberDataChildren(h, data) {
        let nodeList = []
        if (data.userId) {
          let eleString = 'el-checkbox'

          if (this.radioMember) {
            eleString = 'el-radio'
          }

          nodeList.push(h(eleString, {
            props: {
              label: data.userId,
              key: 'userId' + data.userId,
              disabled: this.availableMember(data.userId) ||
                Boolean(data.leave && !this.selected.user.includes(data.userId))||
                Boolean(this.radioMember && data.leave)
            },
            staticClass: 'ry-member-checkbox-item'
          }, [`${data.nickname}(${this.handleTel(data.telephone)})`]))
        } else if (data.depId) {
          nodeList.push(h("span", data.depName))
        }
        return nodeList
      },
      // 渲染选部门 多选
      renderDepDataContent(h, {node, data, store}) {
        let eleString = 'el-checkbox'
        let showDepName = data.depName
        if (this.radioMember) {
          eleString = 'el-radio'
          showDepName = ''
        }
        return h("div", {staticClass: 'ry-dep'}, [
          h(eleString, {
            props: {
              label: data.depId,
              key: 'dep' + data.depId,
              disabled: this.available(this.availableDeps, data.depId)
            },
            nativeOn: {
              click(e) {
                e.stopPropagation()
                return false
              }
            },
            staticClass: 'ry-dep-checkbox-item'
          }, [data.depName]),
          h("span", [showDepName]),
        ])
      },

      // 渲染选角色 多选
      renderRoleDataContent(h, {node, data, store}) {
        return h("div", {staticClass: 'ry-member'}, this.renderRoleDataChildren(h, data))
      },
      // 渲染选角色 多选
      renderRoleDataChildren(h, data) {
        let nodeList = []
        if (data.userId) {
          let eleString = 'el-checkbox'

          if (this.radioMember) {
            eleString = 'el-radio'
          }

          nodeList.push(h(eleString, {
            props: {
              label: data.userId,
              key: 'userId' + data.userId,
              disabled: this.availableMember(data.userId)
            },
            staticClass: 'ry-member-checkbox-item'
          }, [`${data.nickname}(${this.handleTel(data.telephone)})`]))
        } else if (data.roleId) {
          nodeList.push(h("span", data.roleName))
        }
        return nodeList
      },

      // 渲染自定义选人 多选
      renderCustomMemberDataContent(h, {node, data, store}) {
        return h("div", {staticClass: 'ry-member'}, this.renderCustomMemberDataChildren(h, data))
      },
      // 渲染自定义选人 多选
      renderCustomMemberDataChildren(h, data) {
        let nodeList = []
        if (data.userId) {
          let eleString = 'el-checkbox'

          if (this.radioMember) {
            eleString = 'el-radio'
          }

          nodeList.push(h(eleString, {
            props: {
              label: data.userId,
              key: 'userId' + data.userId,
              disabled: this.availableMember(data.userId)
            },
            staticClass: 'ry-member-checkbox-item'
          }, [`${data.userName}`]))
        } else if (data.groupId) {
          nodeList.push(h("span", data.groupName))
        }
        return nodeList
      },

      // 计算是否可选 inside 可选范围  outside 不可选人id
      available(availableList, id) {
        if (availableList && availableList.length) {
          return !availableList.includes(id)
        } else {
          return false
        }
      },
      // 计算是否可选 true是可选，false是不可选
      availableMember(id) {
        // 判断不可选
        if (this.disableMembers.length &&
          this.disableMembers.includes(id)) {
          return true
        }
        // 判断可选
        if (this.availableMembers.length) {
          return !this.availableMembers.includes(id)
        } else {
          return false
        }
      },

      // 自定义渲染函数
      renderLabelListContent(h, {node, data, store}) {
        return h("div", this.renderLabelListChildren(h, data))
      },
      renderLabelListChildren(h, data) {
        let nodeList = []
        if (data.userId) {
          let eleString = 'el-checkbox'

          if (this.radioMember) {
            eleString = 'el-radio'
          }

          nodeList.push(h(eleString, {
            props: {
              label: data.userId,
              key: 'userId' + data.userId,
              disabled: this.availableMember(data.userId)
            },
            staticClass: 'ry-member-checkbox-item'
          }, [`${data.nickname}(${this.handleTel(data.telephone)})`]))
        } else if (data.labelId) {
          nodeList.push(h("span", data.labelName))
        }
        return nodeList
      },

      open() {

        Object.keys(this.customDataMap).forEach(key => {
          delete this.customDataMap[key]
        })
        if (this.currentIsMember && this.hasMember) this.activeTabName = 'member'
        else if (this.currentIsMember && this.hasRole) this.activeTabName = 'role'
        else if (this.hasExternal) {
          this.activeTabName = 'external'
        }
        else if (this.currentIsMember && this.hasLabel) {
          this.activeTabName = 'label'
          this.tabClick()
        }
        else if (this.customTabs.length) {
          this.activeTabName = this.customTabs[0].key
          this.tabClick()
        }

        this.openDialog()
      },
      // 打开弹窗
      openDialog() {
        // 每次打开弹窗将传入的selected数据同步过来
        // const members = this.$store.state.userList.map(user => user.userId)
        // if (members.includes(this.$store.getters.userId)) {
        //   this.isMember = true
        // } else {
        //   this.isMember = false
        // }
        this.isMember = this.$store.getters.adminInfo.isMember

        this.selected = {
          dep: clone(this.selectedDep),
          radioDep: this.selectedDep[0],
          role: clone(this.selectedRole),
          radioRole: this.selectedRole[0],
          user: clone(this.selectedUser ? this.selectedUser : []),
          radioUser: this.selectedUser ? this.selectedUser[0] : '',
          ext: clone(this.selectedExt),
          radioExt: this.selectedExt[0],
          label: clone(this.selectedLabel),
          radioLabel: this.selectedLabel[0],
          dyn: clone(this.selectedDyn).map(dyn => dyn.fieldId),
          radioDyn: clone(this.selectedDyn).map(dyn => dyn.fieldId)[0],
        }
      },
      // 确定按钮
      selectMemberConfirm() {
        const {user, role, dep, dyn, ext, label, radioDep, radioRole, radioUser, radioExt, radioLabel, radioDyn} = this.selected

        if (this.radioMember) {
          if (radioUser) {
            this.selectedUser.splice(0, this.selectedUser.length, radioUser)
          } else {
            this.selectedUser.splice(0, this.selectedUser.length)
          }
          if (radioDep) {
            this.selectedDep.splice(0, this.selectedDep.length, radioDep)
          } else {
            this.selectedDep.splice(0, this.selectedDep.length)
          }
          if (radioRole) {
            this.selectedRole.splice(0, this.selectedRole.length, radioRole)
          } else {
            this.selectedRole.splice(0, this.selectedRole.length)
          }
          if (radioExt) {
            this.selectedExt.splice(0, this.selectedExt.length, radioExt)
          } else {
            this.selectedExt.splice(0, this.selectedExt.length)
          }
          if (radioLabel) {
            this.selectedLabel.splice(0, this.selectedLabel.length, radioLabel)
          } else {
            this.selectedLabel.splice(0, this.selectedLabel.length)
          }
          if (radioDyn) {
            this.selectedDyn.splice(0, this.selectedDyn.length, radioDyn)
          } else {
            this.selectedDyn.splice(0, this.selectedDyn.length)
          }
        } else {
          this.selectedUser.splice(0, this.selectedUser.length)
          this.selectedExt.splice(0, this.selectedExt.length)
          this.selectedUser.push(...clone(user))
          this.selectedExt.push(...clone(ext))
          this.selectedRole.splice(0, this.selectedRole.length, ...clone(role))
          this.selectedLabel.splice(0, this.selectedLabel.length, ...clone(label))
          this.selectedDep.splice(0, this.selectedDep.length, ...clone(dep))

        }

        this.dialogConf.visible = false
        this.$emit('selectedComplete', {
          member: this.selectedUser,
          role: this.selectedRole,
          depart: this.selectedDep,
          external: this.selectedExt,
          label: this.selectedLabel,
          type: 'confirm'
        })
      },

      selectMemberCancel() {
        this.$emit('onCancel')
      },
      emitChange() {
        this.$emit('change', {
          member: this.selectedUser,
          role: this.selectedRole,
          depart: this.selectedDep,
          dynamic: this.selectedDyn,
          external: this.selectedExt,
          label: this.selectedLabel,
          type: 'delete'
        })
      },


      onClickSearch() {
        if (!this.searchInput.length) {
          this.searchResults.member.splice(0, this.searchResults.member.length)
          this.searchResults.dep.splice(0, this.searchResults.dep.length)
          this.searchResults.role.splice(0, this.searchResults.role.length)
          this.searchResults.external.splice(0, this.searchResults.external.length)
          return
        }

        const searchResults = []
        if (this.hasMember) {
          // [...this.$store.state.userList, ...this.$store.state.leaveMemberList].forEach(item => {
          //   let matchStr = item.nickname + item.telephone + item.email
          //   const results = PinyinMatch.match(matchStr, this.searchInput)
          //   if (results) {
          //     searchResults.push(item)
          //   }
          // })

          this.searchLoading = true
          this.searchPageInfo = {
            currentPage: 1,
            pageSize: 50,
            totalPage: 0,
            totalCount: 0
          }
          this.$store.dispatch('actionCompanyMemberSearch', {
            queryStr: this.searchInput,
            ...this.searchPageInfo
          }).then(res => {
            this.searchResults.member = res.dataList.filter(user => !this.availableMember(user.userId))
            this.searchPageInfo.totalPage = res.totalPage
            this.searchPageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.searchLoading = false
          })
        }

        if (this.hasRole) {
          // this.originRole.forEach(item => {
          //
          //   item.userInfoList.forEach(user => {
          //     let matchStr = user.nickname + user.telephone + user.email
          //     const results = PinyinMatch.match(matchStr, this.searchInput)
          //     if (results) {
          //       const existUser = searchResults.filter(r => r.userId === user.userId)[0]
          //       if (!existUser) searchResults.push(user)
          //     }
          //   })
          // })
        }

        const searchExt = []
        if (this.hasExternal) {
          // this.originExts.forEach(item => {
          //   let matchStr = item.orgUserName + item.orgUserMobile
          //   const results = PinyinMatch.match(matchStr, this.searchInput)
          //   if (results) {
          //     searchExt.push(item)
          //   }
          // })
          this.searchExtLoading = true
          this.searchExtPageInfo = {
            currentPage: 1,
            pageSize: 50,
            totalPage: 0,
            totalCount: 0
          }
          this.$store.dispatch('actionNewExternalList', {
            queryStr: this.searchInput,
            ...this.searchExtPageInfo
          })
            .then(res => {
              this.searchExtPageInfo.totalPage = res.totalPage
              this.searchExtPageInfo.currentPage = res.currentPage
              this.searchExtPageInfo.totalCount = res.totalCount
              this.searchResults.external = res.dataList
            }).catch(console.error).finally(() => {
            this.searchExtLoading = false
          })
        }

        if (this.hasLabel) {
          const customData = this.customDataMap['label']

          if (customData) {
            customData.dataList.forEach(item => {

              item.children.forEach(label => {

                label.children.forEach(user => {

                  let matchStr = user.userName + this.handleTel(user.telephone)
                  const results = PinyinMatch.match(matchStr, this.searchInput)
                  if (results) {
                    const existUser = searchExt.filter(r => r.userId === user.userId)[0]
                    if (!existUser) searchExt.push(user)
                  }
                })

              })
            })
          }
        }

        Object.keys(this.customDataMap).forEach(key => {

          if (key !== 'label') {
            const customData = this.customDataMap[key]
            if (customData.resultType === 'LIST') {

              customData.dataList.forEach(user => {
                let matchStr = user.userName + this.handleTel(user.telephone)
                const results = PinyinMatch.match(matchStr, this.searchInput)
                if (results) {
                  if (customData.memberType === 'MEMBER') {
                    const existUser = searchResults.filter(r => r.userId === user.userId)[0]
                    if (!existUser) searchResults.push(user)
                  } else if (customData.memberType === 'EXTERNAL') {
                    const existUser = searchExt.filter(r => r.userId === user.userId)[0]
                    if (!existUser) searchExt.push(user)
                  }
                }
              })

            } else if (customData.resultType === 'GROUP') {
              function eachSearch(list) {
                if (list) {
                  list.forEach(({groupName, groupId, subGroupList, userList = []}) => {
                    userList.forEach(user => {

                      let matchStr = user.userName + this.handleTel(user.telephone)
                      const results = PinyinMatch.match(matchStr, this.searchInput)
                      if (results) {
                        if (customData.memberType === 'MEMBER') {
                          const existUser = searchResults.filter(r => r.userId === user.userId)[0]
                          if (!existUser) searchResults.push(user)
                        } else if (customData.memberType === 'EXTERNAL') {
                          const existUser = searchExt.filter(r => r.userId === user.userId)[0]
                          if (!existUser) searchExt.push(user)
                        }
                      }
                    })

                    eachSearch(subGroupList)
                  })
                }
              }

              eachSearch(customData.dataList)
            }

          }

        })



        this.searchResults.member.splice(0, this.searchResults.member.length, ...searchResults)
        this.searchResults.external.splice(0, this.searchResults.external.length, ...searchExt)

        console.log(this.searchResults)
      },

      tabClick() {
        console.log('tab', this.activeTabName)
        if (['member', 'role', 'external', 'current'].includes(this.activeTabName) ||
          this.customDataMap[this.activeTabName]) {
          return
        }

        this.loading = true
        this.$store.dispatch('actionDynamicChooseMemberGet', {
          appId: this.formSet.appId,
          formId: this.formSet.formId,
          fieldId: this.fieldId,
          ruleKey: this.activeTabName === 'label' ? 'tag' : this.activeTabName,
          data: this.formSet.getValues()
        }).then(res => {
          let dataList = []

          if (res.resultType === 'LIST') {
            dataList = res.dataList

            let map = {}
            res.dataList.forEach(user => {
              map[user.userId] = user
            })
            if (res.memberType === "EXTERNAL") {
              this.$store.commit('UPDATE_EXTERNAL_MAP', map)
            } else if (res.memberType === 'MEMBER') {
              this.$store.commit('UPDATE_USER_MAP', map)
            }
          } else if (res.resultType === 'GROUP') {

            let that = this
            function organizationMap(depList) {
              let list = []
              if (depList) {
                depList.forEach(({groupName, groupId, subGroupList, userList = []}) => {
                  list.push({
                    groupName,
                    groupId,
                    children: [
                      ...userList,
                      ...organizationMap(subGroupList),
                    ]
                  })

                  let map = {}
                  userList.forEach(user => {
                    map[user.userId] = user
                  })

                  if (res.memberType === "EXTERNAL") {
                    that.$store.commit('UPDATE_EXTERNAL_MAP', map)
                  } else if (res.memberType === 'MEMBER') {
                    that.$store.commit('UPDATE_USER_MAP', map)
                  }

                })
              }
              return list
            }

            dataList = organizationMap(res.dataList)

          }

          this.$set(this.customDataMap, this.activeTabName, {
            memberType: res.memberType,
            resultType: res.resultType,
            dataList
          })
        }).catch(console.error)
          .finally(() => {
            this.loading = false
          })
      },
      renderFormTreeContent(h, {node, data, store}) {
        const create = this.$createElement
        let iconClass = "iconfont icon-bumenguanli"
        let titleClass = "dep-item"
        const icon = create("i", {staticClass: iconClass})
        const title = create("div", {staticClass: titleClass}, [icon, h("div", {staticClass: "content-title"}, [data.depName])])

        return create("div", {staticClass: "form-tree-item"}, [title])
      },
      handleMemberTreeNodeClick(data) {
        if (this.$refs.depTree) {
          this.$refs.depTree.setCurrentKey(data.depId)
        }
        this.selectDep.depId = data.depId
        this.selectDep.depName = data.depName
        if (!this.memberMap[data.depId]) {

          this.loading = true

          if (data.depId === 'all') {

            this.pageMap[data.depId] = {
              currentPage: 1,
              pageSize: 50,
              totalPage: 0,
              totalCount: 0
            }
            this.$store.dispatch('actionCompanyUserListV2', {
              depId: data.depId,
              ...this.pageMap[data.depId]
            }).then(res => {
              this.memberMap[data.depId] = res.dataList.filter(user => !this.availableMember(user.userId))
              const pageInfo = this.pageMap[data.depId]
              pageInfo.totalPage = res.totalPage
              pageInfo.totalCount = res.totalCount
            }).catch(console.error).finally(() => {
              this.loading = false
            })

          } else if (data.depId === 'leave') {

            this.memberMap[data.depId] = this.$store.getters.leaveMemberList.filter(user => {
              this.$set(user, 'leave', 1)
              return user
            })
            this.loading = false

          } else {

            this.loading = true

            this.pageMap[data.depId] = {
              currentPage: 1,
              pageSize: 50,
              totalPage: 0,
              totalCount: 0
            }
            this.$store.dispatch('actionCompanyDepMemberList', {
              depId: data.depId,
              ...this.pageMap[data.depId]
            }).then(res => {
              this.memberMap[data.depId] = res.dataList.filter(user => !this.availableMember(user.userId))
              const pageInfo = this.pageMap[data.depId]
              pageInfo.totalPage = res.totalPage
              pageInfo.totalCount = res.totalCount
            }).catch(console.error).finally(() => {
              this.loading = false
            })

          }
        }
      },
      loadMoreUser() {
        if (this.selectDep.depId === 'all') {

          this.loadingMore = true
          const pageInfo = this.pageMap[this.selectDep.depId]
          pageInfo.currentPage++
          this.$store.dispatch('actionCompanyUserListV2', {
            depId: this.selectDep.depId,
            ...pageInfo
          }).then(res => {
            const memberList = this.memberMap[this.selectDep.depId]
            memberList.push(...res.dataList.filter(user => !this.availableMember(user.userId)))
            pageInfo.totalPage = res.totalPage
            pageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.loadingMore = false
          })

        } else if (this.selectDep.depId === 'all') {

        } else {
          this.loadingMore = true
          const pageInfo = this.pageMap[this.selectDep.depId]
          pageInfo.currentPage++
          this.$store.dispatch('actionCompanyDepMemberList', {
            depId: this.selectDep.depId,
            ...pageInfo
          }).then(res => {
            const memberList = this.memberMap[this.selectDep.depId]
            memberList.push(...res.dataList.filter(user => !this.availableMember(user.userId)))
            pageInfo.totalPage = res.totalPage
            pageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.loadingMore = false
          })
        }
      },

      loadMoreSearchUser() {
        this.loadingMore = true
        this.searchPageInfo.currentPage++
        this.$store.dispatch('actionCompanyMemberSearch', {
          queryStr: this.searchInput,
          ...this.searchPageInfo
        }).then(res => {
          this.searchResults.member.push(...res.dataList.filter(user => !this.availableMember(user.userId)))
          this.searchPageInfo.totalPage = res.totalPage
          this.searchPageInfo.totalCount = res.totalCount
        }).catch(console.error).finally(() => {
          this.loadingMore = false
        })
      },
      loadMoreExtSearchUser() {
        this.loadingExtMore = true
        this.searchExtPageInfo.currentPage++
        this.$store.dispatch('actionNewExternalList', {
          queryStr: this.searchInput,
          ...this.searchExtPageInfo
        })
          .then(res => {
            this.searchExtPageInfo.totalPage = res.totalPage
            this.searchExtPageInfo.currentPage = res.currentPage
            this.searchExtPageInfo.totalCount = res.totalCount
            this.searchResults.external.push(...res.dataList)
          }).catch(console.error).finally(() => {
          this.loadingExtMore = false
        })
      },
      renderLabelTreeContent(h, {node, data, store}) {
        const create = this.$createElement
        let iconClass = "iconfont icon-bumenguanli"
        let titleClass = "dep-item"
        const icon = create("i", {staticClass: iconClass})
        const title = create("div", {staticClass: titleClass}, [h("div", {staticClass: "content-title"}, [data.labelName])])

        return create("div", {staticClass: "form-tree-item"}, [title])
      },
      handleLabelTreeNodeClick(data) {
        console.log('handleLabelTreeNodeClick', data)
        if (data.isGroup) {
          return
        }
        if (this.$refs.labelTree) {
          this.$refs.labelTree.setCurrentKey(data.labelId)
        }
        this.selectLabel.labelId = data.labelId
        this.selectLabel.labelName = data.labelName
        if (!this.labelMemberMap[data.labelId]) {

          this.labelLoading = true

          if (data.labelId === 'all') {

            const item = {
              currentPage: 1,
              pageSize: 50,
              totalPage: 0,
              totalCount: 0
            }
            this.$set(this.labelPageMap, data.labelId, item)
            this.$store.dispatch('actionNewExternalList', {
              filterLabelList: [],
              filterType: 0,
              hasTag: 0,
              ...this.labelPageMap[data.labelId]
            }).then(res => {
              this.$set(this.labelMemberMap, data.labelId, res.dataList)
              const pageInfo = this.labelPageMap[data.labelId]
              pageInfo.totalPage = res.totalPage
              pageInfo.totalCount = res.totalCount
            }).catch(console.error).finally(() => {
              this.labelLoading = false
            })

          } else if (data.labelId === 'leave') {

            this.labelMemberMap[data.labelId] = this.$store.getters.leaveExternalList.filter(user => {
              this.$set(user, 'leave', 1)
              return user
            })
            this.labelLoading = false

          } else {

            this.labelLoading = true

            const item = {
              currentPage: 1,
              pageSize: 50,
              totalPage: 0,
              totalCount: 0
            }
            this.$set(this.labelPageMap, data.labelId, item)
            this.$store.dispatch('actionNewExternalList', {
              filterLabelList: [data.labelId],
              filterType: 0,
              hasTag: 1,
              ...this.labelPageMap[data.labelId]
            }).then(res => {
              this.$set(this.labelMemberMap, data.labelId, res.dataList)
              const pageInfo = this.labelPageMap[data.labelId]
              pageInfo.totalPage = res.totalPage
              pageInfo.totalCount = res.totalCount
            }).catch(console.error).finally(() => {
              this.labelLoading = false
            })

          }
        }
      },
      loadMoreExtUser() {
        if (this.selectLabel.labelId === 'all') {

          this.loadingLabelMore = true
          const pageInfo = this.labelPageMap[this.selectLabel.labelId]
          pageInfo.currentPage++

          this.$store.dispatch('actionNewExternalList', {
            filterLabelList: [],
            filterType: 0,
            hasTag: 0,
            ...pageInfo
          }).then(res => {
            const memberList = this.labelMemberMap[this.selectLabel.labelId]
            memberList.push(...res.dataList)
            pageInfo.totalPage = res.totalPage
            pageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.loadingLabelMore = false
          })

        } else if (this.selectLabel.labelId === 'leave') {

        } else {
          this.loadingLabelMore = true
          const pageInfo = this.labelPageMap[this.selectLabel.labelId]
          pageInfo.currentPage++
          this.$store.dispatch('actionNewExternalList', {
            filterLabelList: [this.selectLabel.labelId],
            filterType: 0,
            hasTag: 1,
            ...pageInfo
          }).then(res => {
            const memberList = this.labelMemberMap[this.selectLabel.labelId]
            memberList.push(...res.dataList)
            pageInfo.totalPage = res.totalPage
            pageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.loadingLabelMore = false
          })

        }
      },

      handleRoleTreeNodeClick(data) {
        if (!data) {
          return
        }
        if (this.$refs.roleTree) {
          this.$refs.roleTree.setCurrentKey(data.roleId)
        }
        this.selectRole.roleId = data.roleId
        this.selectRole.roleName = data.roleName
        if (!this.roleMemberMap[data.roleId]) {

          this.roleLoading = true

          const item = {
            currentPage: 1,
            pageSize: 12,
            totalPage: 0,
            totalCount: 0
          }
          this.$set(this.rolePageMap, data.roleId, item)
          this.$store.dispatch('getRoleMemberList', {
            roleId: data.roleId,
            ...this.rolePageMap[data.roleId]
          }).then(res => {
            this.$set(this.roleMemberMap, data.roleId, res.dataList)
            const pageInfo = this.rolePageMap[data.roleId]
            pageInfo.totalPage = res.totalPage
            pageInfo.totalCount = res.totalCount
          }).catch(console.error).finally(() => {
            this.roleLoading = false
          })
        }
      },
      loadMoreRoleUser() {
        this.loadingRoleMore = true
        const pageInfo = this.rolePageMap[this.selectRole.roleId]
        pageInfo.currentPage++
        this.$store.dispatch('getRoleMemberList', {
          roleId: this.selectRole.roleId,
          ...pageInfo
        }).then(res => {
          const memberList = this.roleMemberMap[this.selectRole.roleId]
          memberList.push(...res.dataList)
          pageInfo.totalPage = res.totalPage
          pageInfo.totalCount = res.totalCount
        }).catch(console.error).finally(() => {
          this.loadingRoleMore = false
        })
      },
      allSelectChange() {
        const allSelect = this.allSelectUserMap[this.selectDep.depId]
        if (allSelect) {
          this.selected.user.push(...this.memberMap[this.selectDep.depId].map(item => item.userId))
          this.selected.user = arrayUnique(this.selected.user)
        } else {
          for (let i = this.selected.user.length - 1; i >= 0; i--) {
            const userId = this.selected.user[i]
            if (this.memberMap[this.selectDep.depId].map(item => item.userId).includes(userId)) {
              this.selected.user.splice(i, 1)
            }
          }
        }
      },
      allSelectExtChange() {
        const allSelect = this.allSelectExtMap[this.selectLabel.labelId]
        if (allSelect) {
          this.selected.ext.push(...this.labelMemberMap[this.selectLabel.labelId].map(item => item.userId))
          this.selected.ext = arrayUnique(this.selected.ext)
        } else {
          for (let i = this.selected.ext.length - 1; i >= 0; i--) {
            const userId = this.selected.ext[i]
            if (this.labelMemberMap[this.selectLabel.labelId].map(item => item.userId).includes(userId)) {
              this.selected.ext.splice(i, 1)
            }
          }
        }
      },

      handleTel(tel) {
        if (!tel) {
          return ''
        }
        return hiddenStr(tel, 3, 4)
      }
    },

    watch: {
      'dialogConf.visible'() {
        if (!this.dialogConf.visible) {
          this.searchInput = ''
          this.onClickSearch()
        }
      },
	  'selected.radioUser'(v){
	  	console.log('v==========',this.$store.getters.userListMap[v])
	  }
    }
  }
</script>

<style lang="less">

  .contact-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: calc(env(safe-area-inset-bottom));
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #f7f8fa;

    >.search-container {
      height: 52px;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-input {
        width: 80%;

        .el-input__inner {
          background-color: #f7f8fa;
          border: none;
        }
      }
    }

    .van-tabs {
      height: 44px;
      /*height: calc(100% - 54px - 44px);*/

      /*.van-tabs__content {*/
      /*  height: calc(100% - 44px);*/
      /*  overflow: auto;*/
      /*}*/

      .van-tabs__line {
        background-color: #63B2EE;
      }
    }

    .el-tabs {
      .el-tabs__nav-wrap {
        padding: 0 12px;

        .el-tabs__nav-scroll {
          padding: 0 !important;
        }
      }

      .el-tabs__nav-wrap.is-top {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1px;
          background-color: #E4E7ED;
          z-index: 1;
        }
      }
    }

    .el-tabs {
      height: calc(100% - 172px);
      background-color: #ffffff;

      .el-tabs__header {
        margin-bottom: 0;
      }

      .el-tabs__content {
        height: calc(100% - 40px);
        overflow-y: auto;
        padding-top: 12px;
        -webkit-overflow-scrolling: touch;

        .ry-member {
          position: relative;
          flex: 1;
          height: 20px;

          > span {
            font-size: 14px;
            line-height: 20px;
          }

          > .ry-member-checkbox-item.el-checkbox {
            width: 100%;
            position: relative;
            left: -14px;
          }
        }

        .ry-dep {
          position: relative;
          flex: 1;

          > span {
            font-size: 14px;
            line-height: 1.15;
            position: relative;
            left: 24px;
          }

          > .ry-dep-checkbox-item.el-checkbox {
            position: absolute;
            left: 0;

            span.el-checkbox__label {
              font-size: 0;
            }
          }
        }

        .ry-role {
          .el-checkbox {
            width: 100%;
            padding: 6px 12px;
            margin: 0;
          }
        }


        .ry-label {
          font-size: 14px;

          .el-tree-node {
            background: #ffffff;

            .el-tree-node__content {
              height: auto;
              padding: 2px 0;
              background: #ffffff;

              &:hover {
                background: #ffffff;
              }

              > div {
                width: 100%;
              }
            }
          }

          .el-radio {
            display: block;
            margin-bottom: 5px;
          }

          .el-checkbox {
            box-sizing: border-box;
            display: block;
            width: 100%;
            padding: 6px;
            position: relative;
            left: -6px;

            &:hover {
              background: rgba(0, 0, 0, .12);
            }
          }
        }
      }

      .el-tab-pane {
        > .el-alert {
          text-align: center;

          > .el-alert__content {
            width: 100%;
          }
        }
      }

      .ry-contacts__dynamic-tab-pane {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: row;

        aside {
          width: 150px;
          height: 100%;
          padding: 12px 0;
          border-right: 1px solid #e6e6e6;

          .el-button.el-button--text {
            width: 100%;
            margin: 0;
            text-align: left;
            color: #495060;
            border-radius: 0;

            &.isActive {
              color: #2196f3;
              background-color: fade(#2196f3, 10%);
            }
          }
        }

        section {
          flex: 1;

          > .el-checkbox-group {
            > div {
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 12px;

              > .el-alert {
                .el-alert__content {
                  width: 100%;
                  text-align: center;
                }
              }

              > .el-checkbox {
                display: block;
                margin-bottom: 5px;
              }
            }
          }
        }
      }
    }

    .ry-contacts__box-search-container {
      height: calc(100% - 192px);
      width: 100%;
      border: 1px solid #e6e6e6;
      padding: 10px;
      overflow: auto;
      background-color: #ffffff;

      .item {
        margin-bottom: 10px;


        .title {
          margin-bottom: 10px;
          color: #495060;
        }

        .el-checkbox-group {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .el-checkbox {
            margin-bottom: 5px;
          }
        }
      }

    }

    .select-member-footer {
      height: 100px;
      width: 100%;
      overflow-y: auto;
      margin-top: 6px;
      padding: 6px;
      font-size: 0;
      background-color: #ffffff;

      > .el-tag {
        font-size: 12px;
        margin: 3px;
      }
    }

    .button-container {
      background-color: #ffffff;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid #e6e6e6;

      .van-button {
        margin-right: 20px;
        height: 30px;
      }
    }

    .el-tab-pane {
      height: 100%;
    }

    .select-member-container {
      position: relative;
      height: 100%;
      width: 100%;

      .left-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 40%;
        overflow: auto;
        border-right: 1px solid #e0e0e0;

        .item {
          line-height: 26px;
          cursor: pointer;
          padding: 0 10px;
          font-size: 13px;
        }

        .el-tree-node__content {
          height: 26px;
        }

        .dep-item {
          display: flex;
          line-height: 26px;

          .content-title {
            font-size: 13px;
          }
        }

        .icon-bumenguanli {
          color: #4A66FA;
          margin-right: 10px;
          font-size: 14px;
        }
      }

      .right-container {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 60%;
        padding: 5px;
        overflow-y: auto;
        overflow-x: hidden;

        .el-radio-group,
        .el-checkbox-group {
          display: flex;
          flex-direction: column;

          .el-radio,
          .el-checkbox {
            margin-bottom: 5px;
            display: flex;
            align-items: center;

            .el-radio__label,
            .el-checkbox__label {
              display: flex;
              align-items: center;

              .el-avatar {
                width: 22px;
                height: 22px;
                line-height: 22px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
</style>